import { FC } from 'react';

import { AdminRouter } from '@route/AdminRouter';
import AgencyWorkerMyPage from '@service/bugo/page/AgencyWorkerMyPage';
import BugoBrandAnnouncementAddPage from '@service/bugo/page/BugoBrandAnnouncementAddPage';
import BugoBrandAnnouncementEditPage from '@service/bugo/page/BugoBrandAnnouncementEditPage';
import BugoBrandAnnouncementManagePage from '@service/bugo/page/BugoBrandAnnouncementManagePage';
import BugoMainPage from '@service/bugo/page/BugoMainPage';
import { BugoUpgradePage } from '@service/bugo/page/BugoUpgradePage';
import FeventAddPage from '@service/bugo/page/FeventAddPage';
import FeventManagePage from '@service/bugo/page/FeventManagePage';
import PreferCemeteryPage from '@service/bugo/page/PreferCemeteryPage';
import PreferInfoPage from '@service/bugo/page/PreferInfoPage';
import PreferMournerTextPage from '@service/bugo/page/PreferMournerTextPage';
import UserChangePasswordPage from '@service/bugo/page/UserChangePasswordPage';
import WorkerAccouintPointPage from '@service/bugo/page/WorkerAccountPointPage';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes } from 'react-router-dom';

import BugoBrandIdRouter from './BugoBrandIdRouter';
import FeventIdRouter from './FeventIdRouter';

export const BugoAuthRouter: FC = () => {
  const { isAdmin, isGiftBrandSeller, isStoreSeller, isGiftAgent } = useAuth();

  sessionStorage.removeItem('redirectUrlAfterBugoLogin');

  // 전용 포털을 가진 판매자 role은 부고 메인 대신 각자 포털로 보낸다.
  // (그 외 role은 그대로 부고 메인을 사용)
  const portalRedirect = isGiftBrandSeller()
    ? '/gift-brand'
    : isStoreSeller()
    ? '/flower-seller'
    : isGiftAgent()
    ? '/gift-seller'
    : null;

  return (
    <Routes>
      <Route
        path=""
        element={portalRedirect ? <Navigate to={portalRedirect} /> : <BugoMainPage />}
      />
      <Route path="fevent">
        <Route path="add" element={<FeventAddPage />} />
        <Route path="manage" element={<FeventManagePage />} />
        <Route path=":feventId/*" element={<FeventIdRouter />} />
      </Route>
      <Route path="bugo-brand/*">
        <Route path="announcement/manage" element={<BugoBrandAnnouncementManagePage />} />
        <Route path="announcement/add" element={<BugoBrandAnnouncementAddPage />} />
        <Route
          path="announcement/:announcementId/edit"
          element={<BugoBrandAnnouncementEditPage />}
        />
        <Route path=":bugoBrandId/*" element={<BugoBrandIdRouter />} />
      </Route>
      <Route path="upgrade/select-type" element={<BugoUpgradePage />} />
      {/* 내 문의내역은 문의 페이지의 탭으로 합쳐졌다 — 옛 링크·북마크는 그대로 살린다 */}
      <Route path="my-enquiries" element={<Navigate to="/enquiry?tab=history" replace />} />
      <Route path="user">
        <Route path="mypage" element={<AgencyWorkerMyPage />} />
        <Route path="account-point" element={<WorkerAccouintPointPage />} />
        <Route path="change-password" element={<UserChangePasswordPage />} />
        {/* 편리정보 — 계정관리(mypage)에서 분리한 개인 설정 페이지들 */}
        <Route path="prefer" element={<PreferInfoPage />} />
        <Route path="prefer/cemetery" element={<PreferCemeteryPage />} />
        <Route path="prefer/mourner-text" element={<PreferMournerTextPage />} />
      </Route>
      <Route
        path="admin/*"
        element={isAdmin() ? <AdminRouter /> : <Navigate to="/login" />}
      />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default BugoAuthRouter;
